export default __webpack_public_path__ + "static/media/c1.78b7519f.jpeg";